import { useEffect, useState } from "react";
import { MskScore } from "../../models/interfaces/msk-score";
import { User } from "../../models/interfaces/user";
import moment from "moment";
import NonLinearLineChart from "../charts/non-linear-line-chart";
import { useTranslation } from "react-i18next";
import UserProfilePainAreasAndScales from "../pain-areas/user-profile-pain-areas-and-scales";

const COMPONENT_CLASS = "c-user-profile-assessments";

// -----------------------------------------------------------------------------------------
// #region Intefaces
// -----------------------------------------------------------------------------------------

interface UserProfileSpineClearingProps {
    mskScore?: MskScore;
    user: User;
    allMskScores: MskScore[];
    setAllMskScores: Function;

}

// #endregion Interfaces

// -----------------------------------------------------------------------------------------
// #region Component
// -----------------------------------------------------------------------------------------

const UserProfileSpineClearingV2: React.FC<UserProfileSpineClearingProps> = (props: UserProfileSpineClearingProps) => {
    const { mskScore, allMskScores } = props;
    const [spineClearingHistory, setSpineClearingHistory] = useState<{ x: string, y: number }[]>();
    const { t } = useTranslation();

    useEffect(() => {
        const getHistory = () => {
            if (allMskScores) {
                let tempSpineClearingHistory = []

                for (const mskScore of allMskScores) {
                    tempSpineClearingHistory.push({
                        x: moment(mskScore && mskScore.created?.seconds ? mskScore.created.seconds * 1000 : NaN).format("MMM DD, YY"),
                        y: mskScore.movementScore?.hasSpineClearingPain ? 25 : 75
                    })
                }
                setSpineClearingHistory(tempSpineClearingHistory);
            }
        }
        getHistory();
    }, [allMskScores])

    return (
        <>
            <div className="flex gap-5">
                <div className={`${COMPONENT_CLASS}__score-section-card gap-4 items-center`}>
                    <div className="text-base font-normal">{t('movementFocus.spineClearing')}</div>
                    {mskScore && mskScore?.movementScore && (
                        <div className={`${COMPONENT_CLASS}__movement-group-score-card ${mskScore.movementScore.hasSpineClearingPain ? "bg-red-medium" : "bg-green-medium"}`}>
                            <div className={`${COMPONENT_CLASS}__movement-group-score-card__main-text`}>{mskScore.movementScore.hasSpineClearingPain ? "Fail" : "Pass"}</div>
                            <div className={`${COMPONENT_CLASS}__movement-group-score-card__sub-text`}>{t('userProfile.assessments.goalPass')}</div>
                        </div>
                    )}
                </div>

                {spineClearingHistory && (
                    <div className={`${COMPONENT_CLASS}__score-section-card chart-wrapper grow`}>
                        <NonLinearLineChart
                            dataPoints={spineClearingHistory.map(history => history.y)}
                            labels={spineClearingHistory.map(history => history.x)}
                            title={t('userProfile.assessments.spineHistory')}
                            sectionDetails={{
                                sections: 2,
                                rangeOne: { start: 0, end: 49 },
                                rangeTwo: { start: 50, end: 100 },
                                backgroundColorOrder: { first: "#FFA998", second: "#8BE3CE" },
                                dataPointColorOrder: { first: "#E7514F", second: "#00DFBC" },
                                yAxisLabels: { first: t('general.pain').toUpperCase(), second: t('general.noPain').toUpperCase() },
                                decimals: false
                            }}
                            binaryGraph={{ isTrue: 75, isFalse: 25, trueLabel: t('general.noPain'), falseLabel: t('general.pain') }}
                            toolTipLabel={false} />
                    </div>
                )}
            </div>
            {mskScore?.movementScore?.spineClearingPainAreaAndScale && mskScore?.movementScore?.spineClearingPainAreaAndScale.length > 0 && (
                <div
                    className={`
                ${COMPONENT_CLASS}__score-section-card 
                my-5
            `}
                >
                    <UserProfilePainAreasAndScales
                        painAreasAndScales={mskScore?.movementScore?.spineClearingPainAreaAndScale}
                    />
                </div >
            )}
        </>
    );
}

export default UserProfileSpineClearingV2;
